import React from 'react';
//Context
import { HomeProvider, useHome } from './HomeContext';
//Styles
import '../../styles/home.css';
//Components
import SelectFecha from './SelectFecha';
import CircularGraph from './CircularGraph';
import SelectJerarquia from './SelectJerarquia';
import GanttGraph from './GanttGraph';

function Home() {
    const {
        porU,
        porE,
        mtbf,
        mttr,
        lineSelect,
        filteredLines,
        seriesByLine,
        statusByLine,
        selectedLinea,
    } = useHome();

    return (
        <div className="homeView">
            <div className="homeView-head">
                <div className="homeView-head-titulo">
                    <h1 className="HomeView-head-titulo-h1">Panel principal</h1>
                </div>
                <div className="homeView-head-list">
                    <div className="homeView-head-selectFecha">
                        <SelectFecha />
                    </div>
                    <div className="homeView-head-selectList">{/* <SelectList /> */}</div>
                </div>
            </div>

            <div className="homeView-body">
                <div className="homeView-body-selectLine">
                    <SelectJerarquia />
                </div>

                <div className="homeView-body-kpi-section">
                    {process.env.REACT_APP_ALLOW_HOME_KPI_GRAPH === 'true' && (
                        <div className="homeView-body-circularGraph">
                            <CircularGraph
                                value={porU}
                                tipo={'%'}
                                titulo={'TEEP'}
                                showcontent={1}
                            />
                            <CircularGraph
                                value={porE}
                                tipo={'%'}
                                titulo={'OEE'}
                                showcontent={1}
                            />
                            <CircularGraph
                                value={mtbf}
                                tipo={'hh:mm'}
                                titulo={'MTBF'}
                                showcontent={0}
                            />
                            <CircularGraph
                                value={mttr}
                                tipo={'hh:mm'}
                                titulo={'MTTR'}
                                showcontent={0}
                            />
                        </div>
                    )}
                </div>
                <div className="homeView-body-gantt-section">
                    {process.env.REACT_APP_ALLOW_HOME_GANTT_GRAPH === 'true' && (
                        <div className="homeView-body-GanttGraph">
                            {lineSelect === 0
                                ? filteredLines.map((line) => (
                                    <GanttGraph
                                        key={line.id}
                                        lineId={line.id}
                                        lineName={line.nombre}
                                        series={seriesByLine?.[line.id] || []}
                                        statusColor={statusByLine?.[line.id] || ''}
                                    />
                                ))
                                : <GanttGraph
                                    lineName={selectedLinea?.nombre}
                                />}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

let HomeProviderComp = () => (
    <HomeProvider>
        <Home></Home>
    </HomeProvider>
);

export default HomeProviderComp;
